export default __webpack_public_path__ + "static/media/qr-apple.1363e61e.svg";